/* @flow */
/* eslint-env es6,browser */

export const IDP_COMMONID = 'pubcommonid';
export const IDP_LIVERAMP = 'liveramp';
